import React from 'react';
import moment from 'moment';
import { get } from 'lodash';
import axios from 'axios';
import CursorBasedList from '../../CursorBasedList';

const InternalTransactions = ({walletId}) => {
  const endpoint = `/${gon.currentProvider}/api/wallets/${walletId}/transactions/internal`
  const renderItems = (items) => items.map((transaction) => (
    <div key={transaction.id} className='Table__row'>
      <div className='Table__col'>{transaction.type}</div>
      <div className='Table__col'>{transaction.status}</div>
      <div className='Table__col'>{transaction.amount.toLocaleString()}</div>
      <div className='Table__col'>{transaction.currency}</div>
      <div className='Table__col'>{transaction.nft_id}</div>
      <div className='Table__col'>{transaction.transaction_code}</div>
      <div className='Table__col'>{moment.unix(transaction.created_at).format('YYYY-MM-DD HH:mm')}</div>
    </div>
  ))

  const loadInternalTransactionsViaApi = (endpoint) => {
    return (cursor, callback) => {
      axios.get(
        endpoint, { params: { cursor: cursor } }
      ).then((res) => {
        const data = get(res, 'data')
        if (res.status == 200 && data) {
          callback(data.internal_logs || [], data.cursor)
        }
      })
    }
  }


  return (
    <div>
      <div className='User__header'>
        <h4 className='User__header__h4'>Internal</h4>
      </div>
      <CursorBasedList
        fetchData={loadInternalTransactionsViaApi(endpoint)}
        renderItems={renderItems}
        tableClass='Table--wallet-transactions-internal'
      >
        <div className='Table__row'>
          <div className='Table__col Table__col--th'>Type</div>
          <div className='Table__col Table__col--th'>Status</div>
          <div className='Table__col Table__col--th'>Amount</div>
          <div className='Table__col Table__col--th'>Currency</div>
          <div className='Table__col Table__col--th'>NFT ID</div>
          <div className='Table__col Table__col--th'>Transaction code</div>
          <div className='Table__col Table__col--th'>Created At</div>
        </div>
      </CursorBasedList>
    </div>
  )
}

export default InternalTransactions